module.exports = __webpack_public_path__ + "img/1.e125ceb3.png";